module.exports = __webpack_public_path__ + "3886447add7caba05dd7b9f9910a15f2.svg";